import React, { useState } from 'react';
import { API_URL } from '../config';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus({ loading: true, success: false, error: null });

    try {
      const res = await fetch(`${API_URL}/api/forms/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (res.ok) {
        setStatus({ loading: false, success: true, error: null });
        setEmail('');
        setTimeout(() => setStatus({ loading: false, success: false, error: null }), 5000);
      } else {
        setStatus({ loading: false, success: false, error: 'Failed to subscribe.' });
      }
    } catch (err) {
      console.error(err);
      setStatus({ loading: false, success: false, error: 'Network error.' });
    }
  };

  return (
    <section className="border-t border-white/5 bg-[#121316] py-16 lg:py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute right-0 bottom-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] -z-10 translate-x-1/2 translate-y-1/2"></div>
      
      <div className="max-w-[1200px] mx-auto px-margin-mobile md:px-margin-desktop relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-20">
          
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-[28px] md:text-[36px] font-bold text-silver-text mb-4">
              Get the latest EA drops.
            </h2>
            <p className="text-[14px] md:text-[15px] text-on-surface-variant leading-relaxed max-w-xl mx-auto lg:mx-0">
              Subscribe to our newsletter for exclusive discounts, new product announcements, and free optimal set-file configurations delivered straight to your inbox.
            </p>
          </div>

          <div className="w-full lg:w-[450px] xl:w-[500px] shrink-0">
            {status.success && (
              <div className="mb-4 text-green-400 text-sm font-bold">
                Successfully subscribed!
              </div>
            )}
            {status.error && (
              <div className="mb-4 text-red-400 text-sm font-bold">
                {status.error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
              <input 
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email address"
                className="flex-1 bg-[#1A1B20] border border-white/10 rounded-xl px-5 py-4 text-[14px] text-silver-text focus:outline-none focus:border-primary/50 transition-colors placeholder:text-on-surface-variant/50"
              />
              <button disabled={status.loading} type="submit" className="bg-primary text-[#1A180B] font-bold px-8 py-4 rounded-xl hover:bg-primary/90 transition-all text-[14px] shrink-0 disabled:opacity-50">
                {status.loading ? '...' : 'Subscribe'}
              </button>
            </form>
            <p className="text-[11px] text-on-surface-variant/60 mt-4 text-center sm:text-left">
              By subscribing, you agree to our Terms of Service & Privacy Policy. No spam, ever.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
